module.exports = __webpack_public_path__ + "img/banner03.bb805558.jpg";